// The rename: move browser storage from the old flowmsp.* keys first, before any module reads it.
import '@/lib/legacy-storage';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { oauthRelayUrl } from '@denwen-msp/shared';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/app/auth';
import { router } from '@/app/router';
import { ThemeProvider, useTheme } from '@/app/theme';
import { ConfirmProvider } from '@/components/ui';
import { queryClient } from '@/lib/query';
import { BrandTheme } from '@/modules/branding/brand-theme';
import './styles/index.css';

function Toasts() {
  const { theme } = useTheme();
  // F4: on phones, keep toasts above the technician app's tab bar and timer (/m).
  return <Toaster position="bottom-right" richColors closeButton theme={theme} mobileOffset={{ bottom: 120 }} />;
}

// Phase I: an integration sign-in (HMRC, Microsoft 365, bank, Slack) started on a tenant host comes
// back here, on WEB_ORIGIN, where that admin isn't signed in. The API sends it on to that host.
const relay = oauthRelayUrl(window.location.pathname, window.location.search);
if (relay) {
  window.location.replace(relay);
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            {/* Phase I (I-C): the tenant's colours and favicon */}
            <BrandTheme />
            <ConfirmProvider>
              <RouterProvider router={router} />
              <Toasts />
            </ConfirmProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </StrictMode>,
  );
}
